import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalVariant,
} from '@patternfly/react-core';
import {AlertVariant, useUI} from 'src/contexts/UIContext';
import {useToggleBuildTrigger} from 'src/hooks/UseBuildTriggers';

export default function BuildTriggerToggleModal(
  props: BuildTriggerToggleModalProps,
) {
  const {addAlert} = useUI();
  const {toggleTrigger} = useToggleBuildTrigger(
    props.org,
    props.repo,
    props.trigger_uuid,
    {
      onSuccess: () => {
        addAlert({
          variant: AlertVariant.Success,
          title: `Successfully ${
            props.enabled ? 'disabled' : 'enabled'
          } trigger`,
        });
      },
      onError: (error) => {
        addAlert({
          variant: AlertVariant.Failure,
          title: `Failed to ${props.enabled ? 'disable' : 'enable'} trigger`,
        });
      },
    },
  );
  const title = props.enabled
    ? 'Disable Build Trigger'
    : 'Enable Build Trigger';

  return (
    <Modal
      id="build-trigger-toggle-modal"
      isOpen={props.isOpen}
      onClose={() => props.onClose()}
      variant={ModalVariant.medium}
      style={{
        overflowX: 'visible',
        overflowY: 'visible',
      }}
    >
      <ModalHeader title={title} />
      <ModalBody>
        Are you sure you want to {props.enabled ? 'disable' : 'enable'} this
        build trigger?
      </ModalBody>
      <ModalFooter>
        <Button
          variant="primary"
          onClick={() => {
            toggleTrigger(!props.enabled);
            props.onClose();
          }}
        >
          {title}
        </Button>
        <Button variant="link" onClick={() => props.onClose()}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
}

interface BuildTriggerToggleModalProps {
  org: string;
  repo: string;
  trigger_uuid: string;
  enabled: boolean;
  isOpen: boolean;
  onClose: () => void;
}
